import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem } from '~/views'
import style from './style.css'

export default class ScenarioItem extends React.Component {
  
  static DUPLICATE_EVENT = 'duplicateScenario'

  static REMOVE_EVENT = 'removeScenario'

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const bp = this.props.item;
    return (
      <ListItem className={style.blueprintItem}
        selected={this.props.selected}
        onEvent={this.props.onEvent}
        item={bp}
        title={bp.name}
        subtitle={moment( bp.lastModified ).fromNow()}
        leftView={this.renderLeft()}
        rightView={this.renderRight()} />
    )
  }

  renderLeft() {
    return null;
  }

  renderRight() {

    return (
      <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={this.props.item.id} id={`options-${this.props.item.id}`}>
        <MenuItem bsStyle="link"
          bsSize="large"
          onClick={() => { this.onEvent( ScenarioItem.DUPLICATE_EVENT ) }}> 
          <i className="fa fa-duplicate fa-fw" />
          {' '}
          Duplicate
        </MenuItem>
        <MenuItem divider />
        <MenuItem bsStyle="link"
          bsSize="large" 
          onClick={() => { this.onEvent( ScenarioItem.REMOVE_EVENT ) }}> 
          <i className="fa fa-times-circle fa-fw" />
          {' '}
          Delete
        </MenuItem>
      </DropdownButton>
    )
  }

}
